<template>
	<div class="login" @click="login()">
		<md-card>
			<md-ripple>
				<md-card-header>
					<!-- <div class="md-title">Click to Log In</div> -->
					<div class="md-title">Please wait..</div>
				</md-card-header>
				<!-- <md-card-content>
					Authorize with Auth0...
				</md-card-content> -->
			</md-ripple>
		</md-card>
	</div>
</template>
<script>
export default {
  name: "Login",
  props: ["auth", "authenticated"],
  data() {
    return {
      hasMessages: false
    };
  },
  created() {
	  this.login();
  },
  methods: {
    login() {
      this.auth.login();
    }
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": this.hasMessages
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue